module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/admin-layout/admin-layout.component.scss
// module id = ./src/app/layouts/admin-layout/admin-layout.component.scss
// module chunks = main